/**
 * The header row, in order. Columns are matched by exact name, so the downloadable template, the
 * page's format panel and the validator all have to read from this one list or a file we generated
 * ourselves could fail its own validation.
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get FIELD_HISTORY_IMPORT_ABANDONED_AFTER_MS () {
        return FIELD_HISTORY_IMPORT_ABANDONED_AFTER_MS;
    },
    get FIELD_HISTORY_IMPORT_CLAIM_HANDOFF_MS () {
        return FIELD_HISTORY_IMPORT_CLAIM_HANDOFF_MS;
    },
    get FIELD_HISTORY_IMPORT_COLUMNS () {
        return FIELD_HISTORY_IMPORT_COLUMNS;
    },
    get FIELD_HISTORY_IMPORT_FILE_TOO_LARGE_MESSAGE () {
        return FIELD_HISTORY_IMPORT_FILE_TOO_LARGE_MESSAGE;
    },
    get FIELD_HISTORY_IMPORT_GENERIC_FAILURE_MESSAGE () {
        return FIELD_HISTORY_IMPORT_GENERIC_FAILURE_MESSAGE;
    },
    get MAX_FIELD_HISTORY_IMPORT_ERRORS () {
        return MAX_FIELD_HISTORY_IMPORT_ERRORS;
    },
    get MAX_FIELD_HISTORY_IMPORT_FILE_BYTES () {
        return MAX_FIELD_HISTORY_IMPORT_FILE_BYTES;
    },
    get MAX_FIELD_HISTORY_IMPORT_FILE_MB () {
        return MAX_FIELD_HISTORY_IMPORT_FILE_MB;
    },
    get MAX_FIELD_HISTORY_IMPORT_RECORD_BYTES () {
        return MAX_FIELD_HISTORY_IMPORT_RECORD_BYTES;
    },
    get MAX_FIELD_HISTORY_IMPORT_ROWS () {
        return MAX_FIELD_HISTORY_IMPORT_ROWS;
    },
    get MAX_FIELD_HISTORY_IMPORT_ROWS_LABEL () {
        return MAX_FIELD_HISTORY_IMPORT_ROWS_LABEL;
    },
    get MAX_FIELD_HISTORY_IMPORT_STORED_ENTRIES () {
        return MAX_FIELD_HISTORY_IMPORT_STORED_ENTRIES;
    },
    get MAX_FIELD_HISTORY_IMPORT_TASK_ERRORS () {
        return MAX_FIELD_HISTORY_IMPORT_TASK_ERRORS;
    }
});
const FIELD_HISTORY_IMPORT_COLUMNS = [
    "Email",
    "Field",
    "Field Value",
    "Effective Date"
];
const MAX_FIELD_HISTORY_IMPORT_ROWS = 5000;
const MAX_FIELD_HISTORY_IMPORT_FILE_BYTES = 5 * 1024 * 1024;
const MAX_FIELD_HISTORY_IMPORT_RECORD_BYTES = 64 * 1024;
const MAX_FIELD_HISTORY_IMPORT_STORED_ENTRIES = 100_000;
const MAX_FIELD_HISTORY_IMPORT_ERRORS = 5000;
const MAX_FIELD_HISTORY_IMPORT_TASK_ERRORS = 500;
const MAX_FIELD_HISTORY_IMPORT_ROWS_LABEL = MAX_FIELD_HISTORY_IMPORT_ROWS.toLocaleString("en-US");
const MAX_FIELD_HISTORY_IMPORT_FILE_MB = MAX_FIELD_HISTORY_IMPORT_FILE_BYTES / (1024 * 1024);
const FIELD_HISTORY_IMPORT_GENERIC_FAILURE_MESSAGE = "The import failed. Some entries may already have been imported — check an affected employee's field history before uploading again.";
const FIELD_HISTORY_IMPORT_FILE_TOO_LARGE_MESSAGE = `Files must be ${MAX_FIELD_HISTORY_IMPORT_FILE_MB}MB or smaller.`;
const FIELD_HISTORY_IMPORT_ABANDONED_AFTER_MS = 15.5 * 60 * 1000;
const FIELD_HISTORY_IMPORT_CLAIM_HANDOFF_MS = 30 * 1000;
